import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getWhatIsMyBusiness, logout } from './../../Redux/Actions/UserAction';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import NavDrawer from '../common/NavDrawer';

const BUSINESS_KEYS = {
  CAR01: 'sp-spare-parts-business',
  CAR02: 'sp-garages-business',
  CAR03: 'sp-car-dealers-business',
  CAR04: 'sp-rent-car-business',
  CAR06: 'sp-car-wash-business',
  CAR07: 'sp-car-insurance-business',
  CAR08: 'sp-driving-school-business',
  CAR09: 'sp-car-protection-business',
  CAR10: 'sp-car-towing',
  CAR11: 'sp-taxi-business',
  CAR12: 'sp-air-conditioning-business',
  CAR13: 'sp-quick-services-business',
  CAR14: 'carAgentId',
};

const Home = () => {
  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();
  const home = useSelector((state) => state.home);
  const getMybusiness = home?.getMybusiness;

  // [CF 2026-08-09 #16] Client: the new drawer should open on the home page
  // too. Home renders no <Header/> — it is a full-screen Swiper with its own
  // hamburger — so it mounts the shared <NavDrawer/> and drives it from here.
  const [menuOpen, setMenuOpen] = useState(false);

  const LogOut = () => {
    dispatch(logout());
  };

  useEffect(() => {
    if (sessionStorage.getItem('loged_In') === 'true') {
      dispatch(getWhatIsMyBusiness());
    }
    // Remove custom.css that gets added on non-home pages (it overrides home circle sizes)
    document.querySelectorAll('link[href*="custom.css"]').forEach(el => el.remove());
    // [CF 2026-08-09 #1] Marks the home page so style.css can pin it to the
    // SMALL viewport (100svh) and switch the document scroll off. Without it
    // html{height:100%} resolves against iOS Safari's LARGE viewport, leaving
    // the page scrollable by exactly the URL-bar height — scroll a little, the
    // bar collapses, the overflow disappears and Safari snaps back to the top.
    document.documentElement.classList.add('cav-home');
    // Ensure home page elements are visible (jpreLoader only runs on initial load)
    document.querySelectorAll('.home-logo, .menu-main, section').forEach(el => {
      el.style.opacity = '1';
    });
    // Re-initialize swipers and circle sizing when navigating back to home
    const initHome = () => {
      // Destroy old swipers before re-creating
      if (window.swiperhorizontal && window.swiperhorizontal.destroy) {
        try { window.swiperhorizontal.destroy(true, true); } catch(e) {}
      }
      if (window.swipervertical && window.swipervertical.destroy) {
        try { window.swipervertical.destroy(true, true); } catch(e) {}
      }
      if (typeof window.slideshow === 'function') {
        window.slideshow();
      }
      // Add homepage class to first slides
      document.querySelectorAll('.slideshow-container .swiper-slide:first-child').forEach(el => {
        el.classList.add('homepage');
      });
      // Recalculate circle sizes after layout is stable
      if (typeof window.addRemoveStyle === 'function') {
        window.addRemoveStyle();
      }
    };
    // Run after DOM has rendered and CSS has computed
    const timer1 = setTimeout(initHome, 300);
    // Run again after layout fully settles
    const timer2 = setTimeout(() => {
      if (typeof window.addRemoveStyle === 'function') {
        window.addRemoveStyle();
      }
    }, 800);
    // Cleanup: hide fixed home elements when navigating away
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      document.documentElement.classList.remove('cav-home');
      document.querySelectorAll('.home-logo, .menu-main').forEach(el => {
        el.style.opacity = '0';
      });
    };
  }, [dispatch]);

  useEffect(() => {
    if (getMybusiness && Object.keys(getMybusiness).length > 0) {
      sessionStorage.setItem(
        'paymentPlan',
        getMybusiness?.plan_info && getMybusiness?.daysLeft > 0 ? true : false
      );
      sessionStorage.setItem('BusinessId', getMybusiness?.businessId);
    }
  }, [getMybusiness]);

  function changeLanguage(lang) {
    localStorage.setItem('lang', lang);
    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    i18next.changeLanguage(lang);
    window.location.reload();
  }

  return (
    <div>
      <Link to="/" class="home-logo">
        <img src="assets/images/car-avenue-logo.svg" alt="Car Avenue" />
      </Link>
      {/* [CF 2026-08-09 #16] The hamburger keeps its position and its
          three-line mark (`.menu-main .menu-anchor > span` is drawn in CSS);
          it now opens the shared drawer instead of the old Bootstrap dropdown,
          which listed only login / register / profile / logout. */}
      <div class="menu-main">
        <div class="dropdown">
          <a
            class="dropdown-toggle menu-anchor"
            href="/"
            role="button"
            aria-haspopup="true"
            aria-expanded={menuOpen}
            aria-label={t('Menu')}
            onClick={(e) => {
              e.preventDefault();
              setMenuOpen(true);
            }}
          >
            <span></span>
          </a>
        </div>
      </div>

      <NavDrawer open={menuOpen} onClose={() => setMenuOpen(false)} />

      <section class="banner-main">
        <div class="horizontal-container slideshow-container swiper-container">
          <div class="swiper-wrapper">
            {/* 1. Intro */}
            <div class="swiper-slide homepage">
              <div class="slideshow-contents">
                <div class="circle bg-yellow d-flex align-items-center circle1">
                  <div class="circle-sub w-100">
                    <div class="logo-arrow text-center">
                      <img src="assets/img/logo-arrow.svg" alt="logo" />
                    </div>
                    <h1 class="text-center">
                      {t('Cars Are')}
                      <br /> {t('the Sculptures')}
                      <br /> {t('of our everyday')}
                      <br /> {t('lives')}
                    </h1>
                  </div>
                </div>
                <div class="circle bg-grey1 pattern1 circle2">
                  <div class="position-absolute w-100 h-100">
                    <img
                      src="assets/img/home-img2.png"
                      class="position-absolute img-fluid"
                      alt=""
                    />
                  </div>
                  <div class="position-absolute w-100 h-100">
                    <img
                      src="assets/img/home-img1.png"
                      class="position-absolute img-fluid"
                      alt=""
                    />
                  </div>
                </div>
                <div class="circle bg-yellow pattern2 circle3">
                  <div class="position-absolute w-100 h-100">
                    <img
                      src="assets/img/home-img3.png"
                      class="position-absolute"
                      alt=""
                    />
                  </div>
                </div>
                <div class="circle bg-yellow pattern1  circle4">
                  <div class="position-absolute d-flex align-items-end w-100 h-100">
                    <img
                      src="assets/img/home-car.png"
                      class="position-absolute img-fluid"
                      alt=""
                    />
                  </div>
                  <div class="position-absolute d-flex align-items-end w-100 h-100">
                    <img
                      src="assets/img/location-pin.png"
                      class="position-absolute img-fluid"
                      alt=""
                    />
                  </div>
                </div>
                <div class="circle bg-grey1 pattern2 circle5">
                  <div class="position-absolute w-100 h-100">
                    <img
                      src="assets/img/home-wheel.png"
                      class="position-absolute"
                      alt=""
                    />
                  </div>
                </div>
                <div class="circle bg-dark circle6">
                  <div class="position-absolute d-flex align-items-end w-100 h-100">
                    <img
                      src="assets/img/home-img4.png"
                      class="position-absolute"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* 2. Rent a Car */}
            <div class="swiper-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute w-100 h-100 overflow-radius">
                    <div class="position-absolute justify-content-center align-items-center w-100 h-100 overflow-radius rent-a-car">
                      <img
                        src="assets/imgs/rent-a-car.png"
                        class="position-absolute pos-center"
                        alt="rent a car "
                      />
                    </div>
                  </div>
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 overflow-radius rent-a-car-tag">
                    <img
                      src="assets/imgs/rent-a-car-tag.png"
                      class="position-absolute"
                      alt="rent a car "
                    />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center">
                      <img src="assets/imgs/rent-a-car-icon.svg" alt="garage" />
                    </div>
                    <h1 class="text-center">{t('Rent a Car')}</h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">
                      {t('make your car')} <br /> {t('last longer and')}
                      <br /> {t('attractive')}
                    </h1>
                    <div class="view-dealer-div">
                      <Link
                        to={
                          // sessionStorage.getItem('loged_In') !== 'true'
                          //   ? '/login'
                          //   : '/user-rent-car'
                          '/user-rent-car'
                        }
                        class="view-dealer"
                      >
                        {t('view rent a car')}
                      </Link>
                    </div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 3. Car Dealers */}
            <div class="swiper-slide right-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute w-100 h-100 overflow-radius car-dealers">
                    <img
                      src="assets/imgs/car-dealers.png"
                      class="position-absolute"
                      alt="Car Dealers"
                    />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center">
                      <img src="assets/imgs/dealers-icon.svg" alt="garage" />
                    </div>
                    <h1 class="text-center">{t('Car Dealers')}</h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">
                      {t('make your car')} <br /> {t('last longer and')}
                      <br /> {t('attractive')}
                    </h1>
                    <div class="view-dealer-div">
                      <Link
                        to={
                          // sessionStorage.getItem('loged_In') !== 'true'
                          //   ? '/login'
                          //   : '/user-car-dealers'
                          '/user-car-dealers'
                        }
                        class="view-dealer"
                      >
                        {t('View Car Dealers')}
                      </Link>
                    </div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 4. Cars for Sale */}
            <div class="swiper-slide right-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 overflow-radius car-sale">
                    <img
                      src="assets/imgs/car-for-sale-car.png"
                      class="position-absolute w-100"
                      alt="Cars for Sale"
                    />
                  </div>
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 overflow-radius car-sale-tag">
                    <img
                      src="assets/imgs/car-for-sale-tag.png"
                      class="position-absolute w-100"
                      alt="Cars for Sale"
                    />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center">
                      <img
                        src="assets/imgs/car-for-sale-icon.svg"
                        alt="garage"
                      />
                    </div>
                    <h1 class="text-center">
                      {t('Cars')}
                      <br />
                      {t('for Sale')}
                    </h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">
                      {t('make your car')} <br /> {t('last longer and')}
                      <br /> {t('attractive')}
                    </h1>
                    <div class="view-dealer-div">
                      <Link
                        to={
                          // sessionStorage.getItem('loged_In') !== 'true'
                          //   ? '/login'
                          //   : '/user-cars-for-sale'
                          '/user-cars-for-sale'
                        }
                        class="view-dealer"
                      >
                        {t('view sale cars')}
                      </Link>
                    </div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 5. Car Wash */}
            <div class="swiper-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute w-100 h-100 overflow-radius washing">
                    <img
                      src="assets/imgs/car-wash.png"
                      class="position-absolute"
                      alt="Washing"
                    />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center">
                      <img src="assets/imgs/car-wash-icon.svg" alt="garage" />
                    </div>
                    <h1 class="text-center">{t('Car Wash')}</h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">
                      {t('make your car')} <br /> {t('last longer and')}
                      <br /> {t('attractive')}
                    </h1>
                    <div class="view-dealer-div">
                      <Link to="/user-car-wash" class="view-dealer">
                        {t('view car wash')}
                      </Link>
                    </div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 6. Car Protection */}
            <div class="swiper-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute w-100 h-100 car-protection-shield">
                    <img
                      src="assets/imgs/car-protection-shield.png"
                      class="position-absolute pos-center w-100"
                      alt="Car Protection"
                    />
                  </div>
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 car-protection">
                    <img
                      src="assets/imgs/car-protection.png"
                      class="position-absolute pos-center"
                      alt="Car Protection"
                    />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center">
                      <img
                        src="assets/imgs/car-protection-icon.svg"
                        alt="Car Protection"
                      />
                    </div>
                    <h1 class="text-center">
                      {t('Car')}
                      <br />
                      {t('Protection')}
                    </h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">
                      {t('make your car')} <br /> {t('last longer and')}
                      <br /> {t('attractive')}
                    </h1>
                    <div class="view-dealer-div">
                      <Link to="/user-car-protection" class="view-dealer">
                        {t('view car protection')}
                      </Link>
                    </div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 7. Garage */}
            <div class="swiper-slide garage">
              <div class="slideshow-contents road-div1">
                <div class="circle bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute w-100 h-100 garage-base1">
                    <img
                      src="assets/imgs/garage-base.png"
                      class="position-absolute pos-center"
                      alt="garage"
                    />
                  </div>
                  <div class="position-absolute w-100 h-100 garage-img1">
                    <img
                      src="assets/imgs/garage.png"
                      class="position-absolute pos-center"
                      alt="garage"
                    />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center">
                      <img src="assets/icon/garage-icon.svg" alt="garage" />
                    </div>
                    <h1 class="text-center">{t('Garage')}</h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">
                      {t('make your car')} <br /> {t('last longer and')}
                      <br /> {t('attractive')}
                    </h1>
                    <div class="view-dealer-div">
                      <Link
                        to={
                          // sessionStorage.getItem('loged_In') !== 'true'
                          //   ? '/login'
                          //   : '/user-garages'
                          '/user-garages'
                        }
                        class="view-dealer"
                      >
                        {t('View Garage')}
                      </Link>
                    </div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 8. Spare Parts */}
            <div class="swiper-slide right-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute w-100 h-100 spare-parts">
                    <img
                      src="assets/img/spare-parts.png"
                      class="position-absolute"
                      alt="Spare Parts"
                    />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center">
                      <img
                        src="assets/images/service-icons/spare-parts.svg"
                        alt="garage"
                      />
                    </div>
                    <h1 class="text-center">{t('Spare Parts')}</h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">
                      {t('make your car')} <br /> {t('last longer and')}
                      <br /> {t('attractive')}
                    </h1>
                    <div class="view-dealer-div">
                      <Link
                        to={
                          // sessionStorage.getItem('loged_In') !== 'true'
                          //   ? '/login'
                          //   : '/user-spare-parts'
                          '/user-spare-parts'
                        }
                        class="view-dealer"
                      >
                        {t('View Spare Parts')}
                      </Link>
                    </div>
                    {/* <!--<div class="view-dealer-div"><a href="user-spare-parts.html" class="view-dealer">view Spare Parts</a></div>--> */}
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 9. Quick Services */}
            <div class="swiper-slide right-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 overflow-radius quick-services">
                    <img
                      src="assets/imgs/car-quick-services.png"
                      class="position-absolute"
                      alt="Quick Services"
                    />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center">
                      <img
                        src="assets/imgs/quick-services-icon.svg"
                        alt="logo"
                      />
                    </div>
                    <h1 class="text-center">
                      {t('Quick')}
                      <br />
                      {t('Services')}
                    </h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">
                      {t('Helping')}
                      <br /> {t('you connect to the')}
                      <br /> {t('right dealers')}
                    </h1>
                    <div class="view-dealer-div">
                      <Link to="/user-quick-services" class="view-dealer">
                        {t('view services')}
                      </Link>
                    </div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 10. Air Conditioning */}
            <div class="swiper-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle bg-yellow d-flex align-items-center circle1 circle-inner dark-circle">
                  <div class="position-absolute w-100 h-100 air-conditioning-red">
                    <img
                      src="assets/imgs/air-conditioning-red.png"
                      class="position-absolute pos-center w-100"
                      alt="Air Conditioning"
                    />
                  </div>
                  <div class="position-absolute w-100 h-100 air-conditioning-blue">
                    <img
                      src="assets/imgs/air-conditioning-blue.png"
                      class="position-absolute pos-center w-100"
                      alt="Air Conditioning"
                    />
                  </div>
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 air-conditioning">
                    <img
                      src="assets/imgs/air-conditioning.png"
                      class="position-absolute pos-center w-100"
                      alt="Air Conditioning"
                    />
                  </div>
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 air-conditioning-wheel">
                    <img
                      src="assets/imgs/air-conditioning-wheel.png"
                      class="position-absolute w-100"
                      alt="Air Conditioning"
                    />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center">
                      <img
                        src="assets/images/service-icons/air-conditioning.svg"
                        alt="garage"
                      />
                    </div>
                    <h1 class="text-center">
                      {t('Air')}
                      <br />
                      {t('Conditioning')}
                    </h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">
                      {t('make your car')} <br /> {t('last longer and')}
                      <br /> {t('attractive')}
                    </h1>
                    <div class="view-dealer-div">
                      <Link to="/user-air-conditioning" class="view-dealer">
                        {t('view AC')}
                      </Link>
                    </div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 11. Taxi */}
            <div class="swiper-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute w-100 h-100 overflow-radius taxi-base">
                    <img
                      src="assets/imgs/taxi-base.png"
                      class="position-absolute w-100"
                      alt="Taxi"
                    />
                  </div>
                  <div class="position-absolute w-100 h-100 overflow-radius taxi">
                    <img
                      src="assets/imgs/taxi.png"
                      class="position-absolute w-100"
                      alt="Taxi"
                    />
                  </div>
                  <div class="position-absolute w-100 h-100 taxi-map-pin">
                    <img
                      src="assets/imgs/taxi-map-pin.png"
                      class="position-absolute pos-center"
                      alt="Pin"
                    />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center">
                      <img src="assets/imgs/taxi-icon.svg" alt="garage" />
                    </div>
                    <h1 class="text-center">{t('Taxi')} </h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">
                      {t('make your car')} <br /> {t('last longer and')}
                      <br /> {t('attractive')}
                    </h1>
                    <div class="view-dealer-div">
                      <Link
                        to={
                          // sessionStorage.getItem('loged_In') !== 'true'
                          //   ? '/login'
                          //   : '/user-taxi'
                          '/user-taxi'
                        }
                        class="view-dealer"
                      >
                        {t('view taxi')}
                      </Link>
                    </div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 12. Towing */}
            <div class="swiper-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute w-100 h-100 overflow-radius towing-car">
                    <img
                      src="assets/imgs/towing-car.png"
                      class="position-absolute"
                      alt="Towing"
                    />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center">
                      <img src="assets/imgs/towing-icon.svg" alt="Towing" />
                    </div>
                    <h1 class="text-center">{t('Towing')}</h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">
                      {t('make your car')} <br /> {t('last longer and')}
                      <br /> {t('attractive')}
                    </h1>
                    <div class="view-dealer-div">
                      <Link to="/user-towing" class="view-dealer">
                        {t('view towing')}
                      </Link>
                    </div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 13. Driving School */}
            <div class="swiper-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 overflow-radius">
                    <img
                      src="assets/imgs/car-driving.png"
                      class="position-absolute driving-school-base"
                      alt="Driving School"
                    />
                  </div>
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 overflow-radius">
                    <img
                      src="assets/imgs/driving-school-car.png"
                      class="position-absolute driving-school"
                      alt="Driving School"
                    />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center">
                      <img
                        src="assets/imgs/driving-school-icon.svg"
                        alt="Driving School"
                      />
                    </div>
                    <h1 class="text-center">
                      {t('Driving')}
                      <br /> {t('School')}
                    </h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">
                      {t('make your car')} <br /> {t('last longer and')}
                      <br /> {t('attractive')}
                    </h1>
                    <div class="view-dealer-div">
                      <Link to="/user-driving-schools" class="view-dealer">
                        {t('view driving school')}
                      </Link>
                    </div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 14. Car Insurance */}
            <div class="swiper-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 overflow-radius car-insurance-car">
                    <img
                      src="assets/imgs/car-insurance-car.png"
                      class="position-absolute pos-center car-insurance"
                      alt="car insurance"
                    />
                  </div>
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 car-insurance-shield">
                    <img
                      src="assets/imgs/car-insurance-shield.png"
                      class="position-absolute pos-center car-insurance"
                      alt="car insurance"
                    />
                  </div>
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 car-insurance-pad">
                    <img
                      src="assets/imgs/car-insurance-pad.png"
                      class="position-absolute pos-center car-insurance"
                      alt="car insurance"
                    />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center">
                      <img
                        src="assets/imgs/cars-insurance-icon.svg"
                        alt="car insurance"
                      />
                    </div>
                    <h1 class="text-center">
                      {t('Car')}
                      <br />
                      {t('Insurance')}
                    </h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">
                      {t('make your car')} <br /> {t('last longer and')}
                      <br /> {t('attractive')}
                    </h1>
                    <div class="view-dealer-div">
                      <Link to="/user-car-insurance" class="view-dealer">
                        {t('view insurance')}
                      </Link>
                    </div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* Agents slide hidden - not a category in the original app */}
          </div>
          <div class="swiper-pagination horizontal-pagination"></div>
          <div class="swiper-button-prev slideshow-button-prev horizontal-button-prev">
            <span>{t('Back')}</span>
          </div>
          <div class="swiper-button-next slideshow-button-next horizontal-button-next">
            <div>{t('Discover our services')}</div> <span></span>
          </div>
        </div>
        <div class="vertical-container slideshow-container swiper-container">
          <div class="swiper-wrapper">
            {/* 1. Intro (mobile) */}
            <div class="swiper-slide homepage">
              <div class="slideshow-contents">
                <div class="circle-mobile bg-yellow d-flex align-items-center circle1">
                  <div class="circle-sub w-100">
                    <div class="logo-arrow text-center">
                      <img src="assets/img/logo-arrow.svg" alt="logo" />
                    </div>
                    <h1 class="text-center">
                      {t('Cars Are')}
                      <br /> {t('the Sculptures')}
                      <br /> {t('of our everyday')}
                      <br /> {t('lives')}
                    </h1>
                  </div>
                </div>
                <div class="circle bg-grey1 pattern1 circle2">
                  <div class="position-absolute w-100 h-100">
                    <img src="assets/img/home-img2.png" class="position-absolute img-fluid" alt="" />
                  </div>
                  <div class="position-absolute w-100 h-100">
                    <img src="assets/img/home-img1.png" class="position-absolute img-fluid" alt="" />
                  </div>
                </div>
                <div class="circle bg-yellow pattern2 circle3">
                  <div class="position-absolute w-100 h-100">
                    <img src="assets/img/home-img3.png" class="position-absolute" alt="" />
                  </div>
                </div>
                <div class="circle bg-yellow pattern1 circle4">
                  <div class="position-absolute d-flex align-items-end w-100 h-100">
                    <img src="assets/img/home-car.png" class="position-absolute img-fluid" alt="" />
                  </div>
                  <div class="position-absolute d-flex align-items-end w-100 h-100">
                    <img src="assets/img/location-pin.png" class="position-absolute img-fluid" alt="" />
                  </div>
                </div>
                <div class="circle bg-grey1 pattern2 circle5">
                  <div class="position-absolute w-100 h-100">
                    <img src="assets/img/home-wheel.png" class="position-absolute" alt="" />
                  </div>
                </div>
                <div class="circle bg-dark circle6">
                  <div class="position-absolute d-flex align-items-end w-100 h-100">
                    <img src="assets/img/home-img4.png" class="position-absolute" alt="" />
                  </div>
                </div>
              </div>
            </div>
            {/* 2. Rent a Car (mobile) */}
            <div class="swiper-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle-mobile bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute w-100 h-100 overflow-radius">
                    <div class="position-absolute justify-content-center align-items-center w-100 h-100 overflow-radius rent-a-car">
                      <img src="assets/imgs/rent-a-car.png" class="position-absolute pos-center" alt="rent a car" />
                    </div>
                  </div>
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 overflow-radius rent-a-car-tag">
                    <img src="assets/imgs/rent-a-car-tag.png" class="position-absolute" alt="rent a car" />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center"><img src="assets/imgs/rent-a-car-icon.svg" alt="garage" /></div>
                    <h1 class="text-center">{t('Rent a Car')}</h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">{t('make your car')} <br /> {t('last longer and')}<br /> {t('attractive')}</h1>
                    <div class="view-dealer-div"><Link to="/user-rent-car" class="view-dealer">{t('view rent a car')}</Link></div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 3. Car Dealers (mobile) */}
            <div class="swiper-slide right-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle-mobile bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute w-100 h-100 overflow-radius car-dealers">
                    <img src="assets/imgs/car-dealers.png" class="position-absolute" alt="Car Dealers" />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center"><img src="assets/imgs/dealers-icon.svg" alt="garage" /></div>
                    <h1 class="text-center">{t('Car Dealers')}</h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">{t('make your car')} <br /> {t('last longer and')}<br /> {t('attractive')}</h1>
                    <div class="view-dealer-div"><Link to="/user-car-dealers" class="view-dealer">{t('View Car Dealers')}</Link></div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 4. Cars for Sale (mobile) */}
            <div class="swiper-slide right-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle-mobile bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 overflow-radius car-sale">
                    <img src="assets/imgs/car-for-sale-car.png" class="position-absolute w-100" alt="Cars for Sale" />
                  </div>
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 overflow-radius car-sale-tag">
                    <img src="assets/imgs/car-for-sale-tag.png" class="position-absolute w-100" alt="Cars for Sale" />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center"><img src="assets/imgs/car-for-sale-icon.svg" alt="garage" /></div>
                    <h1 class="text-center">{t('Cars')}<br />{t('for Sale')}</h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">{t('make your car')} <br /> {t('last longer and')}<br /> {t('attractive')}</h1>
                    <div class="view-dealer-div"><Link to="/user-cars-for-sale" class="view-dealer">{t('view sale cars')}</Link></div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 5. Car Wash (mobile) */}
            <div class="swiper-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle-mobile bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute w-100 h-100 overflow-radius washing">
                    <img src="assets/imgs/car-wash.png" class="position-absolute" alt="Washing" />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center"><img src="assets/imgs/car-wash-icon.svg" alt="garage" /></div>
                    <h1 class="text-center">{t('Car Wash')}</h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">{t('make your car')} <br /> {t('last longer and')}<br /> {t('attractive')}</h1>
                    <div class="view-dealer-div"><Link to="/user-car-wash" class="view-dealer">{t('view car wash')}</Link></div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 6. Car Protection (mobile) */}
            <div class="swiper-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle-mobile bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute w-100 h-100 car-protection-shield">
                    <img src="assets/imgs/car-protection-shield.png" class="position-absolute pos-center w-100" alt="Car Protection" />
                  </div>
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 car-protection">
                    <img src="assets/imgs/car-protection.png" class="position-absolute pos-center" alt="Car Protection" />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center"><img src="assets/imgs/car-protection-icon.svg" alt="Car Protection" /></div>
                    <h1 class="text-center">{t('Car')}<br />{t('Protection')}</h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">{t('make your car')} <br /> {t('last longer and')}<br /> {t('attractive')}</h1>
                    <div class="view-dealer-div"><Link to="/user-car-protection" class="view-dealer">{t('view car protection')}</Link></div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 7. Garage (mobile) */}
            <div class="swiper-slide garage">
              <div class="slideshow-contents road-div1">
                <div class="circle-mobile bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute w-100 h-100 garage-base1">
                    <img src="assets/imgs/garage-base.png" class="position-absolute pos-center" alt="garage" />
                  </div>
                  <div class="position-absolute w-100 h-100 garage-img1">
                    <img src="assets/imgs/garage.png" class="position-absolute pos-center" alt="garage" />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center"><img src="assets/icon/garage-icon.svg" alt="garage" /></div>
                    <h1 class="text-center">{t('Garage')}</h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">{t('make your car')} <br /> {t('last longer and')}<br /> {t('attractive')}</h1>
                    <div class="view-dealer-div"><Link to="/user-garages" class="view-dealer">{t('View Garage')}</Link></div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 8. Spare Parts (mobile) */}
            <div class="swiper-slide right-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle-mobile bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute w-100 h-100 spare-parts">
                    <img src="assets/img/spare-parts.png" class="position-absolute" alt="Spare Parts" />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center"><img src="assets/images/service-icons/spare-parts.svg" alt="garage" /></div>
                    <h1 class="text-center">{t('Spare Parts')}</h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">{t('make your car')} <br /> {t('last longer and')}<br /> {t('attractive')}</h1>
                    <div class="view-dealer-div"><Link to="/user-spare-parts" class="view-dealer">{t('View Spare Parts')}</Link></div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 9. Quick Services (mobile) */}
            <div class="swiper-slide right-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle-mobile bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 overflow-radius quick-services">
                    <img src="assets/imgs/car-quick-services.png" class="position-absolute" alt="Quick Services" />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center"><img src="assets/imgs/quick-services-icon.svg" alt="logo" /></div>
                    <h1 class="text-center">{t('Quick')}<br />{t('Services')}</h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">{t('Helping')}<br /> {t('you connect to the')}<br /> {t('right dealers')}</h1>
                    <div class="view-dealer-div"><Link to="/user-quick-services" class="view-dealer">{t('view services')}</Link></div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 10. Air Conditioning (mobile) */}
            <div class="swiper-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle-mobile bg-yellow d-flex align-items-center circle1 circle-inner dark-circle">
                  <div class="position-absolute w-100 h-100 air-conditioning-red">
                    <img src="assets/imgs/air-conditioning-red.png" class="position-absolute pos-center w-100" alt="Air Conditioning" />
                  </div>
                  <div class="position-absolute w-100 h-100 air-conditioning-blue">
                    <img src="assets/imgs/air-conditioning-blue.png" class="position-absolute pos-center w-100" alt="Air Conditioning" />
                  </div>
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 air-conditioning">
                    <img src="assets/imgs/air-conditioning.png" class="position-absolute pos-center w-100" alt="Air Conditioning" />
                  </div>
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 air-conditioning-wheel">
                    <img src="assets/imgs/air-conditioning-wheel.png" class="position-absolute w-100" alt="Air Conditioning" />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center"><img src="assets/images/service-icons/air-conditioning.svg" alt="garage" /></div>
                    <h1 class="text-center">{t('Air')}<br />{t('Conditioning')}</h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">{t('make your car')} <br /> {t('last longer and')}<br /> {t('attractive')}</h1>
                    <div class="view-dealer-div"><Link to="/user-air-conditioning" class="view-dealer">{t('view AC')}</Link></div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 11. Taxi (mobile) */}
            <div class="swiper-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle-mobile bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute w-100 h-100 overflow-radius taxi-base">
                    <img src="assets/imgs/taxi-base.png" class="position-absolute w-100" alt="Taxi" />
                  </div>
                  <div class="position-absolute w-100 h-100 overflow-radius taxi">
                    <img src="assets/imgs/taxi.png" class="position-absolute w-100" alt="Taxi" />
                  </div>
                  <div class="position-absolute w-100 h-100 taxi-map-pin">
                    <img src="assets/imgs/taxi-map-pin.png" class="position-absolute pos-center" alt="Pin" />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center"><img src="assets/imgs/taxi-icon.svg" alt="garage" /></div>
                    <h1 class="text-center">{t('Taxi')}</h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">{t('make your car')} <br /> {t('last longer and')}<br /> {t('attractive')}</h1>
                    <div class="view-dealer-div"><Link to="/user-taxi" class="view-dealer">{t('view taxi')}</Link></div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 12. Towing (mobile) */}
            <div class="swiper-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle-mobile bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute w-100 h-100 overflow-radius towing-car">
                    <img src="assets/imgs/towing-car.png" class="position-absolute" alt="Towing" />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center"><img src="assets/imgs/towing-icon.svg" alt="Towing" /></div>
                    <h1 class="text-center">{t('Towing')}</h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">{t('make your car')} <br /> {t('last longer and')}<br /> {t('attractive')}</h1>
                    <div class="view-dealer-div"><Link to="/user-towing" class="view-dealer">{t('view towing')}</Link></div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 13. Driving School (mobile) */}
            <div class="swiper-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle-mobile bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 overflow-radius">
                    <img src="assets/imgs/car-driving.png" class="position-absolute driving-school-base" alt="Driving School" />
                  </div>
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 overflow-radius">
                    <img src="assets/imgs/driving-school-car.png" class="position-absolute driving-school" alt="Driving School" />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center"><img src="assets/imgs/driving-school-icon.svg" alt="Driving School" /></div>
                    <h1 class="text-center">{t('Driving')}<br /> {t('School')}</h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">{t('make your car')} <br /> {t('last longer and')}<br /> {t('attractive')}</h1>
                    <div class="view-dealer-div"><Link to="/user-driving-schools" class="view-dealer">{t('view driving school')}</Link></div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
            {/* 14. Car Insurance (mobile) */}
            <div class="swiper-slide">
              <div class="slideshow-contents road-div2">
                <div class="circle-mobile bg-yellow d-flex align-items-center circle1 circle-inner">
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 overflow-radius car-insurance-car">
                    <img src="assets/imgs/car-insurance-car.png" class="position-absolute pos-center car-insurance" alt="car insurance" />
                  </div>
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 car-insurance-shield">
                    <img src="assets/imgs/car-insurance-shield.png" class="position-absolute pos-center car-insurance" alt="car insurance" />
                  </div>
                  <div class="position-absolute justify-content-center align-items-center w-100 h-100 car-insurance-pad">
                    <img src="assets/imgs/car-insurance-pad.png" class="position-absolute pos-center car-insurance" alt="car insurance" />
                  </div>
                </div>
                <div class="circle bg-very-dark d-flex align-items-center pattern3 circle-title">
                  <div class="circle-sub w-100">
                    <div class="title-icon text-center"><img src="assets/imgs/cars-insurance-icon.svg" alt="car insurance" /></div>
                    <h1 class="text-center">{t('Car')}<br />{t('Insurance')}</h1>
                  </div>
                </div>
                <div class="circle bg-grey3 d-flex align-items-center pattern4 circle-slogan">
                  <div class="circle-sub w-100">
                    <h1 class="text-center">{t('make your car')} <br /> {t('last longer and')}<br /> {t('attractive')}</h1>
                    <div class="view-dealer-div"><Link to="/user-car-insurance" class="view-dealer">{t('view insurance')}</Link></div>
                  </div>
                </div>
                <div class="circle bg-yellow circle-common1"> </div>
                <div class="circle bg-dark3 circle-common2"> </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination vertical-pagination" style={{ display: 'none' }}></div>
          <div class="swiper-button-prev slideshow-button-prev vertical-button-prev" style={{ display: 'none' }}>
            <span>{t('Back')}</span>
          </div>
          <div class="swiper-button-next slideshow-button-next vertical-button-next" style={{ display: 'none' }}>
            <div>{t('Discover our services')}</div> <span></span>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
